export default __webpack_public_path__ + "static/media/nn_book_cover_on_white.5ecfe21a.png";